<template>
	<div id="app" class="wrapper">
		<router-view></router-view>
	</div>
</template>
<script>
	export default {
		name: 'App'
	}
</script>
<style lang="scss">
	@import "sass/main"
</style>




// WEBPACK FOOTER //
// App.vue?8265fb6e